module.exports = __webpack_public_path__ + "img/two2Red.dfebee23.png";